module.exports = __webpack_public_path__ + "7524e806056a7ebe26d59244a9a350bb.svg";